"use strict";

const $ = jQuery;

module.exports = class {
	#$module;
    #$toggleButtons;

	#data;

	constructor($module, data) {
        this.#data = data;
		this.#$module = $module;
        this.#$toggleButtons = this.#$module.find('button.toggle-btn');

		this.bind();
	}

	bind() {
        this.$toggleButtons.on('click', (event) => { return this.onToggleButtonClick(event); });
	}

    get $module() {
        return this.#$module;
    }

    get $toggleButtons() {
        return this.#$toggleButtons;
    }

    get data() {
        return this.#data;
    }

    get id() {
        return this.data.node;
    }

    onToggleButtonClick(event) {
        if (!(event.originalEvent instanceof PointerEvent) && !(event.originalEvent instanceof MouseEvent)) {
            return null;
        }

        const $target = $(event.target);

        if ($target.hasClass('agent-toggle')) {
            this.$module.removeClass('is-agency');

            if (this.$module.hasClass('is-agent')) {
                this.$module.removeClass('is-agent');
            } else {
                this.$module.addClass('is-agent');
            }

            return true;
        }

        if ($target.hasClass('agency-toggle')) {
            this.$module.removeClass('is-agent');

            if (this.$module.hasClass('is-agency')) {
                this.$module.removeClass('is-agency');
            } else {
                this.$module.addClass('is-agency');
            }

            return true;
        }
    }
}